import { Children, forwardRef } from 'react';
import { Assert } from '@team/assert';
import { clsx } from '@team/clsx';
import { RootComponent } from '../../../../services/root-component';
import { LayoutProps } from '../../types';
import { Mode } from '../../enums';
import { modePresets } from './model';
import css from './style.module.css';

export const Entry = forwardRef<HTMLElement, LayoutProps>(function Component(
  { mode = Mode.DEFAULT, children, ...props },
  forwardedRef
) {
  if (import.meta.env.DEV) {
    if (
      [props['aria-label'], props['aria-labelledby']].every(Assert.isUndefined)
    ) {
      console.warn(
        '[TelegramUi.CompactPagination]: a11y police. Отсутствует один из пропсов: `aria-label` или `aria-labelledby`. Например, "Слайды".'
      );
    }
  }

  return (
    <RootComponent
      {...props}
      Component="nav"
      baseClassName={clsx(css.root, modePresets[mode])}
      ref={forwardedRef}
    >
      <ol className={css.list}>
        {Children.map(children, (child, key) => (
          <li key={key} className={css.item}>
            {child}
          </li>
        ))}
      </ol>
    </RootComponent>
  );
});
